export default __webpack_public_path__ + "d2df90fef4b181a8005173d6ab04f20f.svg";